/* eslint-disable max-len */
import bgb from './model_json/BGB.json';
import bluntschli from './model_json/Bluntschli.json';
import dresdenerEntwurf from './model_json/DresdenerEntwurf.json';
import eugenHuber from './model_json/EugenHuber.json';
import glueck from './model_json/VonGlueck.json';
import jhering from './model_json/Jhering.json';
import reichsJustizGesetze from './model_json/ReichsJustizGesetze.json';
import savigny from './model_json/Savigny.json';
import warnkoenig from './model_json/warnkoenig.json';
import windscheid from './model_json/Windscheid.json';
import or from './model_json/SchweizerischesObligationenrecht.json';
import zgb from './model_json/SchweizerischesZivilgesetzbuch.json';
import handelsgesetzbuch from './model_json/HGB.json';
import cpo from './model_json/CPO.json';
import polor from './model_json/PolOR.json';
import alr from './model_json/ALR.json';
import vtuhr from './model_json/VonTuhr.json';
import keller from './model_json/Keller.json';
import andreasheusler from './model_json/Heusler.json';
import kempin from './model_json/Kempin.json';
import mackenroth from './model_json/Mackenroth.json';
import gierke from './model_json/Gierke.json';
import locre from './model_json/locre.json';
import rossel from './model_json/Rossel.json';
import ehrlich from './model_json/Ehrlich.json';
import bundesverfassung from './model_json/Bundesverfassung.json';
import gottliebplanck from './model_json/Planck.json';
import unger from './model_json/Unger.json';
import reichskammergericht from './model_json/Reichskammergericht.json';

const model = [
  reichskammergericht,
  glueck,
  locre,
  savigny,
  warnkoenig,
  keller,
  alr,
  bluntschli,
  windscheid,
  jhering,
  gottliebplanck,
  unger,
  andreasheusler,
  gierke,
  bundesverfassung,
  eugenHuber,
  kempin,
  rossel,
  handelsgesetzbuch,
  mackenroth,
  ehrlich,
  vtuhr,
  cpo,
  dresdenerEntwurf,
  reichsJustizGesetze,
  or,
  bgb,
  zgb,
  polor,
];

export default model;
